import {Injectable} from '@angular/core';
import {ConnectorService} from './connector.service';
import {Observable} from 'rxjs';
import {MemberModel, UserRightsModel} from '../../models/user.model';
import {
    DepartmentModel,
    DepartmentUserModel,
    DivisionModel,
    IExtendedStructureDepartmentModel,
    StructureDepartmentModel
} from '../../models/department.model';

@Injectable({
    providedIn: 'root'
})
export class DepartmentsService extends ConnectorService {
    /**
     * Создание нового департамента
     * @param data
     */
    createDepartment(data): Observable<{
        message: string,
        department: DepartmentModel,
    }> {
        return this.post('instance/dag/department', data);
    }

    /**
     * Удаление департамента
     * @param data
     */
    deleteDepartment(data): Observable<{
        message: string
    }> {
        return this.delete('instance/dag/department', data);
    }

    /**
     * Список доступных департаментов
     */
    getDepartments(): Observable<{
        departments: DepartmentModel[]
    }> {
        return this.get('instance/dag/departments');
    }

    /**
     * Получение департаментов вместе с их отделами
     * @param memberGuid (при указании гуида работает как поиск по пользователю)
     */
    getStructureDepartments(memberGuid = ''): Observable<IExtendedStructureDepartmentModel> {
        return this.get('instance/dag/department/structure?user_guid=' + memberGuid);
    }

    /**
     * Список пользователей в департаменте
     *
     * @param departmentId
     */
    getDepartmentUsers(departmentId): Observable<{
        users: DepartmentUserModel[]
    }> {
        return this.get('instance/dag/departments/users', {id: departmentId});
    }

    /**
     * Добавление пользователя в депортамент
     * Если пользователя нет в проекте, ему будет выслан инвайт
     *
     * @param data
     */
    inviteUserToDepartment(data): Observable<any> /*{
        message: string,
        department_id: number,
        user: MemberModel,
    }>*/ {
        return this.post('instance/dag/department/user', data);
    }

    /**
     * Удаление пользователя из департамента
     * @param data
     */
    deleteUserFromDepartment(data): Observable<{
        message: string,
        department: DepartmentModel,
        project_user_guid: string
    }> {
        return this.delete('instance/dag/departments/user/', data);
    }

    /**
     * Список прав департамента
     * @param departmentId
     */
    getDepartmentRights(departmentId): Observable<{
        message: string,
        rights: UserRightsModel[]
    }> {
        return this.get('instance/dag/rights/department', {department_id: departmentId});
    }

    /**
     * Установка прав для департамента
     * @param data
     */
    setDepartmentRights(data): Observable<{
        message: string,
        rights: UserRightsModel
    }> {
        return this.put('instance/dag/rights/department', data);
    }

    /**
     * Обновление прав департамента на элемент
     * @param data
     */
    updateDepartmentRights(data): Observable<{
        message: string,
        rights: UserRightsModel
    }> {
        return this.put('instance/dag/rights/department', data);
    }

    /**
     * Удаление прав на элемент
     * @param data
     */
    deleteDepartmentRights(data): Observable<{
        message: string
    }> {
        return this.delete('instance/dag/rights/department', data);
    }

    /**
     * Редактирование департамента
     * @param id
     * @param name
     * @returns
     */
    updateDepartment(id, name): Observable<{
        department: DepartmentModel,
        message: string
    }> {
        return this.put('instance/dag/department', {id, name});
    }

    /**
     * Изменение прав пользователя админ\не админ
     * @param data
     * @returns
     */
    setUsersRightsInDepartment(data): Observable<any> {
        return this.put('instance/dag/department/admin', data);
    }

    /**
     * получение всех отделов департамента
     * @param departmentId
     */
    getDepartmentDivisions(departmentId: number): Observable<{
        department: {
            divisions: DivisionModel[],
            department: DepartmentModel,
            members: {
                [key: string]: MemberModel
            }
        }
    }> {
        return this.get('instance/dag/divisions/' + departmentId);
    }

    /**
     * Создание отдела в департаменте
     * @param data
     */
    createDivision(data: {
        department_id: number,
        name: string,
        parent_id: number | null
    }): Observable<any> {
        return this.post('instance/dag/division', data);
    }

    /**
     * Добавить пользователя в отдел
     * @param data
     */
    addMemberToDivision(data: {
        department_id: number,
        division_id: number,
        email: string
    }): Observable<any> {
        return this.post('instance/dag/division/user', data);
    }

    /**
     * Изменение названия отдела
     * @param divisionId
     * @param name
     */
    editDivision(divisionId: number, name: string): Observable<any> {
        return this.put('instance/dag/division/' + divisionId, {name});
    }

    /**
     * удалить отдел
     * @param divisionId
     */
    deleteDivision(divisionId: number): Observable<any> {
        return this.delete('instance/dag/division/' + divisionId);
    }

    /**
     * удалить пользователя из отдела
     * @param divisionId
     * @param memberGuid
     */
    deleteMemberFromDivision(divisionId: number, memberGuid: string): Observable<any> {
        return this.delete('instance/dag/division/user/' + divisionId + '/' + memberGuid);
    }
}
